module.exports = __webpack_public_path__ + "static/media/keunggulan-1.1875cb19.png";